import * as routerActionTypes from './types';
import * as routerActions from './actions';
import reducer from './reducer';

export {
  routerActionTypes,
  routerActions
};

export default reducer;